module.exports = __webpack_public_path__ + "img/logo_hammer.d4825749.jpg";